import clsx from 'clsx';
import React, { ReactNode } from 'react';

import Switch from '@/src/components/common/Switch/Switch';

type DisabledProps = {
  disabled: boolean;
  content?: ReactNode;
};

type InboxItemSettingsProps = {
  className?: string;
  content: string;
  isActive: number;
  layout: string;
  isEnabled: number;
  disabled?: DisabledProps | boolean;
  tooltipSettings?;
  children?: ReactNode;
  onSwitchChange: () => void;
};

const InboxItemSettings = ({
  className,
  content,
  isActive,
  layout,
  isEnabled,
  disabled,
  tooltipSettings,
  onSwitchChange,
}: InboxItemSettingsProps) => {
  const isDisabled = typeof disabled === 'boolean' ? disabled : disabled?.disabled;
  const disabledContent = typeof disabled === 'object' ? disabled.content : undefined;

  return (
    <div
      className={clsx(
        'formSection',
        'tw-flex tw-items-center tw-justify-between',
        layout === 'view' ? 'viewOnly' : 'onEdit',
        className
      )}
    >
      <span className={clsx('tw-text-cfo-black', 'tw-m-0 tw-p-0')}>{content}</span>

      {layout === 'form' && (
        <div className={clsx('tw-flex tw-items-center')}>
          {disabledContent}

          <Switch
            isActive={isActive}
            onChange={onSwitchChange}
            tooltip={tooltipSettings}
            disabled={isDisabled}
          />
        </div>
      )}
      {layout === 'view' && (
        <span className={clsx('tw-text-cfo-black')}>{isEnabled ? 'Yes' : 'No'}</span>
      )}
    </div>
  );
};

export default InboxItemSettings;
